/*
 * Loby review-section enhancer.
 *
 *  - fills our custom 5->1 histogram from the counts baked into the
 *    legacy Judge.me widget HTML (parked in a <template>)
 *  - wires our proxy controls (Write a review / Ask a question / Filters /
 *    sort) to the real Judge.me widget controls
 *  - injects a "Verified" chip (~85%, deterministic) and a "City, CC"
 *    location line onto each review card (test store — cosmetic only)
 *
 * All lookups are defensive: if Judge.me changes its markup the worst
 * case is a control quietly does nothing.
 */
(function () {
  if (window.__lobyReviewsEnhance) return;
  window.__lobyReviewsEnhance = true;

  var PLACES = ('Portland, US|Austin, US|Denver, US|Seattle, US|Boston, US|Chicago, US|' +
    'Sacramento, US|Nashville, US|Columbus, US|Raleigh, US|San Diego, US|Phoenix, US|' +
    'Brooklyn, US|Minneapolis, US|Tampa, US|Boise, US|Madison, US|Asheville, US|' +
    'Toronto, CA|Vancouver, CA|Calgary, CA|Ottawa, CA|Montreal, CA|Halifax, CA|' +
    'Thunder Bay, CA|Victoria, CA|London, GB|Manchester, GB|Bristol, GB|Leeds, GB|' +
    'Glasgow, GB|Brighton, GB|Cardiff, GB|Sydney, AU|Melbourne, AU|Brisbane, AU|' +
    'Perth, AU|Adelaide, AU|Auckland, NZ|Wellington, NZ|Berlin, DE|Munich, DE|' +
    'Hamburg, DE|Cologne, DE|Amsterdam, NL|Rotterdam, NL|Dublin, IE|Cork, IE|' +
    'Copenhagen, DK|Stockholm, SE|Oslo, NO|Paris, FR|Lyon, FR|Lisbon, PT|' +
    'Madrid, ES|Barcelona, ES|Milan, IT|Vienna, AT|Zurich, CH').split('|');

  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h;
  }

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function qs(root, sel) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function qsa(root, sel) { try { return (root || document).querySelectorAll(sel); } catch (e) { return []; } }

  // ---- histogram ----------------------------------------------------------
  function fillHistogram(root) {
    var box = qs(root, '[data-loby-hist]');
    var tpl = qs(root, '[data-loby-jm-source]');
    if (!box || !tpl || !tpl.content) return;
    var rows = tpl.content.querySelectorAll('.jdgm-histogram__row[data-rating]');
    if (!rows.length) return;
    var freq = {};
    var max = 0;
    each(rows, function (r) {
      var star = r.getAttribute('data-rating');
      var f = parseInt(r.getAttribute('data-frequency') || '0', 10) || 0;
      freq[star] = f;
      if (f > max) max = f;
    });
    if (!max) return;
    each(qsa(box, '.loby-rev-hist-row'), function (row) {
      var star = row.getAttribute('data-star');
      var f = freq[star] || 0;
      var fill = row.querySelector('.loby-rev-hist-row__fill');
      var count = row.querySelector('.loby-rev-hist-row__count');
      if (fill) fill.style.width = Math.round((f / max) * 100) + '%';
      if (count) count.textContent = f;
    });
    box.hidden = false;
  }

  // ---- proxy controls ---------------------------------------------------
  function widgetRoot() {
    return qs(document, '.jm-review-widget') || qs(document, '.jdgm-rev-widg') || document;
  }

  function clickReal(selectors) {
    var w = widgetRoot();
    for (var i = 0; i < selectors.length; i++) {
      var el = qs(w, selectors[i]) || qs(document, selectors[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }

  // Judge.me's revamp buttons ignore a bare .click() — they need a full
  // pointer+mouse gesture.
  function realGesture(el) {
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
      var E = t.indexOf('pointer') === 0 ? (window.PointerEvent || MouseEvent) : MouseEvent;
      try {
        el.dispatchEvent(new E(t, { bubbles: true, cancelable: true, composed: true, view: window, button: 0 }));
      } catch (e) { try { el.dispatchEvent(new Event(t, { bubbles: true })); } catch (e2) {} }
    });
  }

  function wireProxies(root) {
    var write = qs(root, '[data-loby-write]');
    var ask = qs(root, '[data-loby-ask]');

    if (write && !write.__wired) {
      write.__wired = 1;
      write.addEventListener('click', function () {
        var w = widgetRoot();
        var btn = qs(w, '.jm-action-buttons__button') || qs(w, '.jm-button--primary') ||
                  qs(document, '.jdgm-write-rev-link');
        if (btn) {
          realGesture(btn);
          setTimeout(function () {
            var f = qs(document, '.jm-form-wrapper, [class*="jm-review-form"], .jdgm-form-wrapper, form.jdgm-form');
            if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 250);
        }
      });
    }
    if (ask && !ask.__wired) {
      ask.__wired = 1;
      ask.addEventListener('click', function () {
        var w = widgetRoot();
        var btn = qs(w, '.jm-ask-question-link') || qs(w, '.jdgm-ask-question-link') ||
                  qs(w, '.jm-custom-questions__ask-button') || qs(w, '[class*="ask-question"]');
        if (btn) realGesture(btn);
        else ask.style.display = 'none';
      });
    }
  }

  // ---- custom sort dropdown (native <select> popup can't be site-styled) ----
  function buildSortMenu() {
    var sel = qs(document, '.jm-sort-filter__select');
    var box = sel && sel.closest('.jm-sort-filter');
    if (!sel || !box || box.__sortMenu) return;
    box.__sortMenu = 1;

    var opts = Array.prototype.slice.call(sel.options);
    var menu = document.createElement('div');
    menu.className = 'loby-sort__menu';
    menu.setAttribute('role', 'listbox');
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'loby-sort__opt';
      b.textContent = o.text;
      b.dataset.value = o.value;
      b.setAttribute('role', 'option');
      if (o.selected) b.setAttribute('aria-selected', 'true');
      b.addEventListener('click', function () {
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        each(menu.children, function (c) { c.removeAttribute('aria-selected'); });
        b.setAttribute('aria-selected', 'true');
        setLabel(o.text);
        box.classList.remove('is-open');
      });
      menu.appendChild(b);
    });

    var label = document.createElement('span');
    label.className = 'loby-sort__label';
    function setLabel(t) { label.textContent = t; }
    setLabel((sel.options[sel.selectedIndex] || {}).text || 'Sort');

    box.classList.add('loby-sort');
    box.insertBefore(label, box.firstChild);
    box.appendChild(menu);

    box.addEventListener('click', function (e) {
      if (e.target.closest('.loby-sort__menu')) return;
      box.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!box.contains(e.target)) box.classList.remove('is-open');
    });

    // keep label in sync if Judge.me changes sort some other way
    sel.addEventListener('change', function () {
      setLabel((sel.options[sel.selectedIndex] || {}).text || 'Sort');
    });
  }

  // ---- verified + location injection -----------------------------------
  function reviewCards() {
    var w = widgetRoot();
    var cards = qsa(w, '.jm-review-item, .jdgm-rev, .jdgm-review-list > li, .jdgm-review-list > div');
    return cards.length ? cards : qsa(document, '.jm-review-item, .jdgm-rev');
  }

  function nameEl(card) {
    return qs(card, '.jm-reviewer-info__name, .jdgm-rev__author, [class*="reviewer-info__name"], [class*="reviewer-name"], [class*="review-author"], [class*="review"] [class*="author"]');
  }

  function enhanceCard(card) {
    if (card.getAttribute('data-loby-enhanced')) return;
    var nm = nameEl(card);
    if (!nm) return;
    card.setAttribute('data-loby-enhanced', '1');

    var nmeta = (nm.textContent || '').trim().toLowerCase();
    var seed = hash((card.getAttribute('data-review-id') || '') + '|' + (nm.textContent || '') + '|' + (card.textContent || '').slice(0, 40));

    // always-verified overrides (name fragment, lowercase)
    var FORCE_VERIFIED = ['nadia g'];
    var forced = FORCE_VERIFIED.some(function (n) { return nmeta.indexOf(n) === 0 || nmeta.indexOf(n) > -1; });

    // Verified chip (~85%, or forced) — ignore EMPTY judge.me badge wrappers
    var hasVerified = !!qs(card, '.loby-rev-verified');
    if (!hasVerified) {
      each(qsa(card, '[class*="verified"], [class*="buyer-badge"]'), function (e) {
        if ((e.textContent || '').trim()) hasVerified = true;
      });
    }
    if ((forced || (seed % 100) < 85) && !hasVerified) {
      var chip = document.createElement('span');
      chip.className = 'loby-rev-verified';
      chip.textContent = 'Verified';
      var slot = qs(card, '[class*="buyer-badge-wrapper"], [class*="buyer-badge"]');
      if (slot && !(slot.textContent || '').trim()) {
        slot.appendChild(chip);
      } else {
        // put it right after the name span
        nm.parentNode.insertBefore(chip, nm.nextSibling);
      }
    }

    // location line under the name
    var city = PLACES[(seed >>> 3) % PLACES.length];
    var existingLoc = qs(card, '.jdgm-rev__location, [class*="review-location"], [class*="reviewer-location"]');
    if (existingLoc && !(existingLoc.textContent || '').trim()) {
      existingLoc.textContent = city;
      existingLoc.classList.add('loby-rev-location');
    } else if (!qs(card, '.loby-rev-location') && !(existingLoc && (existingLoc.textContent || '').trim())) {
      var loc = document.createElement('div');
      loc.className = 'loby-rev-location';
      loc.textContent = city;
      // revamp: drop it into .jm-reviewer-info__details; legacy: after the name row
      var details = qs(card, '.jm-reviewer-info__details') ||
        nm.closest('[class*="author-wrapper"], [class*="profile"], [class*="reviewer"], [class*="row-profile"], [class*="info__details"]') ||
        nm.parentNode;
      details.appendChild(loc);
    }
  }

  function enhanceAll() { each(reviewCards(), enhanceCard); }

  function syncControls(root) {
    if (!root) return;
    root.classList.toggle('loby-reviews--has-jm', !!qs(document, '.jm-review-widget'));
  }

  // If the Judge.me block was added as its OWN section (below ours), pull the
  // revamp widget up into our section and drop the legacy fallback + its
  // now-empty host section, so there's a single widget under our header.
  function consolidateWidget(root) {
    if (!root || root.__consolidated) return;
    var jm = qs(document, '.jm-review-widget');
    if (!jm || root.contains(jm)) return;

    var mover = jm.closest('#judgeme_product_reviews') || jm.closest('.shopify-block') || jm;
    var hostSection = mover.closest('.shopify-section');

    // remove our legacy fallback (+ its template source is fine to keep)
    each(qsa(root, '#judgeme_product_reviews'), function (el) { el.remove(); });

    // place the real widget right after our header
    var anchor = qs(root, '.loby-rev-head') || qs(root, '.loby-section-head');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(mover, anchor.nextSibling);
    else root.appendChild(mover);

    // hide the emptied standalone section so it leaves no gap
    if (hostSection && hostSection !== root.closest('.shopify-section') && !hostSection.querySelector('.jm-review-widget')) {
      hostSection.style.display = 'none';
    }
    root.__consolidated = true;
  }

  // ---- work around Judge.me fighting the reskin ----------------------
  function hardenWidget(root) {
    if (!root) return;

    // a) defeat the "hide until our JS runs" guards if that JS is slow/broken
    each(qsa(root, 'style.jdgm-temp-hiding-style'), function (s) { s.remove(); });
    each(qsa(root, '.jdgm-temp-hidden, .jm-temp-hidden'), function (el) {
      el.classList.remove('jdgm-temp-hidden', 'jm-temp-hidden');
    });
    each(qsa(root, '.jdgm-rev-widg, .jm-review-widget'), function (el) {
      if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    });

    // b) last-resort star recolour — strip any inline brand colour Judge.me's
    //    JS painted on, and force ink on svg fills
    each(qsa(root, '[class*="star"], [class*="Star"]'), function (el) {
      if (el.style && el.style.color) el.style.color = '';
      if (el.hasAttribute && el.hasAttribute('fill') && el.getAttribute('fill') !== 'currentColor') {
        el.setAttribute('fill', 'currentColor');
      }
    });
    each(qsa(root, 'svg[class*="star"] path, [class*="star"] svg path'), function (p) {
      if (p.getAttribute('fill') && p.getAttribute('fill') !== 'currentColor') p.setAttribute('fill', 'currentColor');
    });

    // c) drop branding / promo rows
    each(qsa(root, '[class*="branding"], [class*="powered-by"], [class*="__promo"]'), function (el) {
      if (el.style.display !== 'none') el.style.display = 'none';
    });

    // d) hide only the redundant header PIECES (title / average / histogram /
    //    Write-a-review) — NOT the filters+sort row or the filter panel.
    each(qsa(root,
      '.jm-review-widget-minimal-header__title,' +
      '.jm-review-widget__title,' +
      '.jm-average-rating-display,' +
      '.jm-review-widget-minimal-header__action-buttons,' +
      '.jm-action-buttons,' +
      '.jm-review-widget [class*="histogram"],' +
      '.jdgm-rev-widg__header, .jdgm-row-stars'
    ), function (el) {
      if (el.style.display !== 'none' && !el.closest('.loby-rev-head')) el.style.display = 'none';
    });
  }

  function pass() {
    var root = qs(document, '[data-loby-reviews]');
    if (root) {
      consolidateWidget(root);
      fillHistogram(root);
      wireProxies(root);
      buildSortMenu();
      syncControls(root);
      hardenWidget(root);
    }
    enhanceAll();
  }

  // ---- boot -----------------------------------------------------------
  function boot() {
    pass();

    // one durable observer on the whole section — survives Judge.me
    // replacing the widget body / header on sort / filter / pagination
    var root = qs(document, '[data-loby-reviews]');
    if (root && !root.__lobyObs) {
      root.__lobyObs = 1;
      new MutationObserver(function () {
        clearTimeout(boot.__t);
        boot.__t = setTimeout(pass, 100);
      }).observe(root, { childList: true, subtree: true });
    }
  }

  // Judge.me loads async — poll a few times, then rely on the observer.
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    boot();
    if (widgetRoot() !== document || tries > 30) clearInterval(iv);
  }, 400);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
